import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'

import pic03 from '../assets/images/pic03.jpg'

const MuffinsCookies = (props) => (
    <Layout>
        <Helmet>
            <title>Muffins and Cookies</title>
            <meta name="description" content="Muffins and cookies" />
            <html lang="en"/>
        </Helmet>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <header className="major">
                        <h1>Muffins and Cookies</h1>
                    </header>
                        <div className="grid-wrapper">
                            <span className="image fit col-6"><img src={pic03} alt="Muffins" /></span>
                            <div className="col-6">
                                <p>A Muffin is a small domed spongy cake made with eggs and baking powder.</p>
                                <p>A cookie is a sweet biscuit.</p>
                            </div>
                        </div>
                </div>
            </section>
        </div>

    </Layout>
)

export default MuffinsCookies